// Fetch Data
import {getPropertyDetail} from '../dataSource/fileManager'

const getFile = async propertySelected => {
	let files = []

	await Promise.all(propertySelected.map(async res => {
		let propertyDetail = await getPropertyDetail(res)

		console.log("***** propertyDetail : ",propertyDetail)

		if (propertyDetail.data) {
			propertyDetail.data.map(property => {

				if (property.property_files) {
					property.property_files.map(file => {
						file.file_subject = property.file_subject
						file.dms_property_seq = property.property_seq
						files.push(file)
					})
				}

			})
		}
	}))

	return files
}


// const getFile = async propertySelected => {
// 	let files = []

// 	await Promise.all(propertySelected.map(async res => {
// 		const propertyDetail = await getPropertyDetail(res)

// 		files.push(...propertyDetail.data[0].property_files)
// 	}))

// 	return files
// }


const getSubject = async propertySelected => {
	let subject = ""

	await Promise.all(propertySelected.map(async res => {
		const propertyDetail = await getPropertyDetail(res)
		const tempSubject = propertyDetail.data[0].file_subject !== null ? propertyDetail.data[0].file_subject : ""

		propertySelected.length === 1 ?
			subject = tempSubject
		:
			subject = subject.concat(" ", "[" + tempSubject + "]")
	}))

	return subject
}


export {getFile, getSubject}